import { type WorkspaceRepository } from '@telespot/domain';
import { ListUserMemberships } from './list-user-memberships.command';
import { type CommandHandler } from '@telespot/core';

export enum ListUserMembershipsError {
  WORKSPACE_NOT_FOUND = 'Workspace ID does not match the ID of any workspace in the database',
}

export interface UserMembership {
  membershipId?: string;
  workspaceId: string;
  workspaceName: string;
}

export type IListUserMembershipsHandler = CommandHandler<ListUserMemberships>;

export class ListUserMembershipsUseCase implements IListUserMembershipsHandler {
  constructor(private readonly workspaceRepository: WorkspaceRepository) {}

  public async execute(command: ListUserMemberships): Promise<UserMembership[]> {
    const memberships = await this.workspaceRepository.listUserMemberships(
      command.details.userId,
      command.details.organizationId
    );

    return memberships.map(({ workspace, member }) => ({
      membershipId: member.id,
      workspaceId: workspace.id,
      workspaceName: workspace.name,
    }));
  }
}
